import { commonToast } from '@/components/commonFunctions/commonToast';
import { Box, Button, Icon } from '@mui/material';
import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const UpChunk = require('@mux/upchunk'); 

const DropZone = (props) => { 
  const [fileQueue, setFileQueue] = useState({
    queue: [],
    finished: [],
  });
  /* eslint-disable-next-line */
  const [uploadInfo, setuploadInfo] = useState({
    generated: null,
    original: null,
  });

  const handleUpload = (info) => {
    //for uploading success toast message
    const succeeded = info != null && (!Array.isArray(info) || info.length > 0);
    if (succeeded && !props.disableSuccessToast) {
      commonToast('success', 'Successfully uploaded');
    }
    //for uploading success toast message

    setuploadInfo(info);
    props.uploadHandler && props.uploadHandler(info);
  };
  const handleError = (error) => {
    console.log('DropZone handleError', error);
    try {
      props.errorHandler && props.errorHandler(error.response.data.message);
      props.uploadHandler && props.uploadHandler(null);
      setFileQueue({
        queue: [],
        finished: [],
      });
    } catch (error) {
      console.log('DropZone handleError', error);
    }
  };
  const handleProgress = (event) => {
    props.progressHandler && props.progressHandler(event);
  };

  const getSignedRequest = (file, callback) => {
    props.uploadStart && props.uploadStart(file);
    if (props.video) {
      axios
        .get(
          `${props.uploadurl}?file-name=${encodeURIComponent(
            file.name
          )}&file-type=${file.type}`
        )
        .then((response) => {
          props.signingFinished && props.signingFinished(response);
          const upload = UpChunk.createUpload({
            file,
            // Normally this would be retrieved via an API request to an endpoint
            // you control that would return an authenticated URL.
            endpoint: response.data.url,
            chunkSize: 5120, // Uploads the file in ~5mb chunks
          });
          upload.on('error', handleError);
          upload.on('progress', handleProgress);
          upload.on('success', handleUpload);
        })
        .catch(handleError);
    } else {
      axios
        .get(
          `${props.uploadurl}?file-name=${encodeURIComponent(
            file.name
          )}&file-type=${file.type}&file-size=${file.size}`
        )
        .then((response) => {
          uploadFile(
            file,
            response.data.signedRequest,
            () => {
              const retVal = {
                generated: response.data.generatedName,
                original: file.name,
              };
              callback ? callback(retVal) : handleUpload(retVal);
            },
            handleError
          );
        })
        .catch(handleError);
    }
  };

  const uploadFile = (file, signedRequest, callback, errorHandler) => {
    axios
      .put(signedRequest, file)
      .then(() => {
        callback();
      })
      .catch(errorHandler);
  };

  const recursiveUpload = () => {
    props.queueStatus && props.queueStatus(fileQueue);
    if (fileQueue.queue.length > 0) {
      getSignedRequest(fileQueue.queue[0], (result) => {
        const newFileQueue = { ...fileQueue };
        newFileQueue.queue.shift();
        newFileQueue.finished.push(result);
        setFileQueue(newFileQueue);
      });
    } else {
      console.log('Finished');
    }
  };

  useEffect(() => {
    if (fileQueue.queue.length > 0) {
      recursiveUpload();
    } else if (fileQueue.finished.length > 0) {
      // Finished
      console.log('Finished', fileQueue);
      handleUpload(fileQueue.finished);
      setFileQueue({
        queue: [],
        finished: [],
      });
    }
  }, [fileQueue.queue.length]);

  const onDrop = useCallback((acceptedFiles) => {
    console.log('onDrop', acceptedFiles);
    if (props.multiple && acceptedFiles.length > 0) {
      setFileQueue({
        queue: acceptedFiles,
        finished: [],
      });
    } else if (acceptedFiles.length === 1) {
      getSignedRequest(acceptedFiles[0]);
    } else {
      console.log('Drop only one image');
    }
    // Do something with the files
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    ...(props.acceptedfiletypes ? { accept: props.acceptedfiletypes } : {}),
    multiple: props.multiple || false,
    disabled: props.disabled || false,
  });

  return (
    <Box
      {...getRootProps()}
      style={props.style} // 👈 used for  style
      sx={props.sx} // 👈 used sx (preferred in MUI)
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <p>Drop the files here ...</p>
      ) : (
        <Button
          size="small"
          startIcon={props.startIcon || <Icon>photo</Icon>}
          disabled={props.disabled || false}
          variant={props.variant || 'contained'}
          color="primary"
        >
          {props.buttonText || 'Choose image'}
        </Button>
      )}
    </Box>
  );
};

export default DropZone;
